import { type RecordingBatch } from '@reliance/types/models/RecordingBatch';
import { type AuthToken } from '@reliance/types/models/Auth';
import { type PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import { type ApiService } from '../types/ApiService';
import config from '../services/config';

export const recordingBatch = (
  centralApi: ApiService,
  getToken: () => AuthToken,
) => ({
  index: (params = {}): Promise<PaginatedResponse<RecordingBatch>> => {
    return centralApi.get('/recording-batch', { params });
  },
  get: (id) => {
    return centralApi.get(`/recording-batch/${id}`);
  },
  getDownloadUrl: (id) => {
    return `${config.centralApi.url}/recording-batch/${id}/download?token=${
      getToken().accessToken
    }`;
  },
});
